import { createTheme } from "@mui/material/styles";

export const pharmadosTheme = createTheme({
  palette: {
    primary: {
      main: "#00A8E8",
      dark: "#005094",
      light: "#EDF1F5",
    },
    secondary: {
      main: "#666666",
      dark: "#333333",
      light: "#00AAEB",
    },
    common: {
      black: "#000000",
      white: "#FFFFFF",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 945,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    fontFamily: "nunito, sans-serif",
    body1: {
      fontWeight: 600,
      fontSize: 20,
      lineHeight: "20px",
    },
    body2: {
      fontWeight: 600,
      fontSize: 18,
      lineHeight: "18px",
    },
  },
});
